import { isBrowser } from "./browser.helper";
import { classes } from "./detect-input-method.helper";

let tabCounter = 0;
let accessibilityModeActive = false;
let eventListenerActive = false;

// Declare here because of eslint/no-use-before-define
// eslint-disable-next-line prefer-const
export let removeAccessibilityHelperEvent: () => void;
// eslint-disable-next-line prefer-const
export let addAccessibilityHelperEvent: () => void;

// Set accessibility mode
export function setAccessibilityMode(value: boolean): void {
    if (isBrowser) {
        if (value) {
            document.body.classList.add(classes.usingTab);
            accessibilityModeActive = true;
            removeAccessibilityHelperEvent();
        } else {
            document.body.classList.remove(classes.usingTab);
            accessibilityModeActive = false;
            addAccessibilityHelperEvent();
        }
    }
}

function detectAccessibilityMode(event: KeyboardEvent): void {
    if (isBrowser) {
        let isInsideForm = false;
        let element = event.target as any; // eslint-disable-line
        while (element.parentElement) {
            element = element.parentElement;
            // Check if near parent is form.
            // If inside form we do not activate the accessibility mode
            if (element.tagName === 'FORM') {
                isInsideForm = true;
                break;
            } else if (element.tagName === 'BODY') {
                isInsideForm = false;
                break;
            }
        }
        if (!isInsideForm) {
            tabCounter++;
            // If not, activate accessibility mode
            if (tabCounter === 2) {
                setAccessibilityMode(true);
            }
            // Reset the counter, if user does not press tab rapidly
            setTimeout(() => {
                tabCounter = 0;
            }, 5000);
        }
    }
}

function handleKeyDown(event: KeyboardEvent): void {
    if (!accessibilityModeActive) {
        if (event.key === "Tab" || event.which === 9) {
            detectAccessibilityMode(event);
        }
    }
}

removeAccessibilityHelperEvent = (): void => {
    if (isBrowser) {
        eventListenerActive = false;
        window.removeEventListener("keydown", handleKeyDown);
    }
}

addAccessibilityHelperEvent = (): void => {
    if (isBrowser && !eventListenerActive) {
        eventListenerActive = true;
        window.addEventListener("keydown", handleKeyDown);
    }
}
